import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, Route } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Route[] = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then( m => m.HomePage),
    canActivate: [AuthGuard]
  },
  {
    path: 'articulos',
    loadComponent: () => import('./pages/articulos/articulos.page').then( m => m.ArticulosPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'clientes',
    loadComponent: () => import('./pages/terceros/terceros.page').then( m => m.TercerosPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'documentos',
    loadComponent: () => import('./pages/documentos/documentos.page').then( m => m.DocumentosPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'proveedores',
    loadComponent: () => import('./pages/terceros/terceros.page').then( m => m.TercerosPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'documentos-compra',
    loadComponent: () => import('./pages/documentos/documentos.page').then( m => m.DocumentosPage),
    canActivate: [AuthGuard]
  }



];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
export { routes };
